<template>
  <section class="sec_404">
    <div class="box-p-20 border text-center">
      <h1>404</h1>
      <p>お探しのページが見つかりませんでした。</p>
    </div>
    <div class="box-p-20 text-center">
      <a href="./top.html" class="btn d-inline-block">ログイン画面へ</a>
    </div>
  </section>
</template>

<style scoped>
.sec_404 {
  height: calc(100vh - 239px);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>

<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
